import axios from 'axios';

const API_URL = '/categories';

// Fetch all categories
const getCategories = async () => {
    const response = await axios.get(API_URL);
    return response.data.data;
};

// Create a new category
const createCategory = async (categoryData) => {
    const response = await axios.post(API_URL, categoryData, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });
    return response.data.data;
};

// Delete a category
const deleteCategory = async (id) => {
    const response = await axios.delete(`${API_URL}${id}`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });
    return id; // Return the deleted category ID
};

const categoryService = {
    getCategories,
    createCategory,
    deleteCategory,
};

export default categoryService;
